import { render, staticRenderFns } from "./rich-editor-widget.vue?vue&type=template&id=4f54e1e5&scoped=true&"
import script from "./rich-editor-widget.vue?vue&type=script&lang=js&"
export * from "./rich-editor-widget.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor-widget.vue?vue&type=style&index=0&id=4f54e1e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54e1e5",
  null
  
)

export default component.exports